import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import halfOverlayBanner from "../assets/images/ProjectWithIveyBanner.jpg"
import ContactPopup from './ContactPopup';

const ProjectWithIvey = () => {
  const [isPopup, setPopup] = useState(false)
  return (
    <>
      <div className="project-with-ivey half-overlay-banner color-light position-relative">
        <picture className="w-100 bottom-overlay position-absolute w-100 h-100">
          <source media="(max-width:768px)" srcSet={halfOverlayBanner} />
          <img className="cover" src={halfOverlayBanner} alt="" />
        </picture>
        <div className='contant-box d-flex position-absolute w-100 h-100 top-0 start-0'>
          <div className="left-block d-flex flex-column justify-center">
            <div className="summary mb-30 d-mb-50" data-aos="fade-up" data-aos-delay="100" data-aos-duration="600">
              <h2 className='mb-20'>Get started on your own project <span className='d-block font-medium'>with Ivey DB</span></h2>
              <div className='text-block font18 mb-25'>Get in touch with our team now.</div>
              <div className='button button-blur' onClick={() => setPopup(true)}>Start Now</div>
            </div>
          </div>
          <div className="right-block h-100 d-flex align-end py-60 d-px-120 py-60">

          </div>
        </div>
      </div>
      {isPopup === true ?
        <>
          <ContactPopup setPopup={setPopup} />
        </> : <></>}

    </>
  )
}

export default ProjectWithIvey